import { Component, Input, OnInit } from '@angular/core';
import { App } from '@galaxy/marketplace-apps';
import { Package } from '@vendasta/marketplace-packages';
import { ItemSelectorConfig, SelectedItem, SelectionChange } from '@galaxy/inventory-ui';
import { ItemSelectorAdapterService } from './item-selector-adapter.service';
import { Observable } from 'rxjs';
import { AppWithRetailPricing } from '../sales-order-line-item-selector.component';

@Component({
  selector: 'sales-ui-sales-order-item-selector-adapter',
  templateUrl: './item-selector-adapter.component.html',
  providers: [ItemSelectorAdapterService],
})
export class ItemSelectorAdapterComponent implements OnInit {
  @Input() config: ItemSelectorConfig;
  @Input() selectedApps: App[];
  @Input() selectedPackages: Package[];

  selectedItems: SelectedItem[];

  constructor(private itemSelectorAdapterService: ItemSelectorAdapterService) {}

  ngOnInit() {
    this.selectedItems = ItemSelectorAdapterService.convertAppsAndPackagesToItems(
      this.selectedApps,
      this.selectedPackages,
    );
  }

  itemSelectionChanged(selectionChange: SelectionChange): void {
    this.selectedItems = selectionChange.selectedItems;
  }

  getAppsWithRetailPricing(): Observable<AppWithRetailPricing[]> {
    return this.itemSelectorAdapterService.getAppsWithRetailPricing(
      this.selectedItems,
      this.config.partnerId,
      this.config.marketId,
    );
  }

  getMarketplacePackages(): Observable<Package[]> {
    return this.itemSelectorAdapterService.getMarketplacePackages(this.selectedItems);
  }
}
